import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import FlexBox from 'components/common/FlexBox';
import { IconButton } from '@totalsoft/rocket-ui';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import TextTableCell from 'components/common/table/TextTableCell';

const ReportVerificationItem = ({ data, onDownloadSentDataFile, onDownloadReceivedDataFile, showExtendedColumns }) => {
  const { t } = useTranslation();

  return (
    <TableRow hover key={data.id}>
      <TableCell>{data.id}</TableCell>
      <TableCell>{moment(data.createdDate).format('DD.MM.YYYY HH:MM:SS')}</TableCell>
      <TableCell>{data.userName}</TableCell>
      <TableCell>{data.service}</TableCell>
      <TableCell>{data.entityName}</TableCell>
      <TextTableCell content={data.method} />
      {showExtendedColumns && (
        <>
          <TableCell>{data.extended?.orderId}</TableCell>
          <TableCell>{data.extended?.documentNumber}</TableCell>
          <TableCell>{data.extended?.status}</TableCell>
        </>
      )}
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton
            color='primary'
            size='small'
            variant='text'
            tooltip={t('ReportsVerification.SentData')}
            onClick={() => onDownloadSentDataFile(data.externalId, data.service)}
          >
            <CallMadeIcon fontSize='small' />
          </IconButton>
          <IconButton
            color='primary'
            size='small'
            variant='text'
            tooltip={t('ReportsVerification.ReceivedData')}
            onClick={() => onDownloadReceivedDataFile(data.externalId, data.service)}
          >
            <CallReceivedIcon fontSize='small' />
          </IconButton>
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

ReportVerificationItem.propTypes = {
  data: PropTypes.array.isRequired,
  onDownloadSentDataFile: PropTypes.func.isRequired,
  onDownloadReceivedDataFile: PropTypes.func.isRequired,
  showExtendedColumns: PropTypes.bool
};

export default ReportVerificationItem;
